(() => {
  const seasonLabels = {
    'Spring (Cherry Blossoms); Autumn (Maple Leaves)': 'Spring & Autumn',
    'Winter (Snow); Spring (Cherry Blossoms); Autumn (Maple Leaves)': 'Winter, Spring & Autumn',
    'Year-round': 'Year-round',
    'Year-round; Spring (Cherry Blossoms); Autumn (Maple Leaves)': 'Year-round · Best in Spring & Autumn',
    'Year-round; Winter (Snow)': 'Year-round · Best in Winter'
  };

  function enhanceSeasonFilter(root = document) {
    root.querySelectorAll('input[name="filter.p.m.custom.travel_season"]').forEach((input) => {
      const label = input.closest('li')?.querySelector('.checkbox__label-text');
      const nextLabel = seasonLabels[input.value];
      if (label && nextLabel && label.textContent !== nextLabel) label.textContent = nextLabel;
    });

    root.querySelectorAll('product-card[data-travel-season]').forEach((card) => {
      if (card.querySelector('.leda-season-badge')) return;
      let raw = card.dataset.travelSeason?.trim();
      if (!raw) return;
      // Older rendered cards may contain Shopify's JSON list representation.
      // Normalize it so shoppers see a clean season label instead of ["..."] .
      if (raw.startsWith('[')) {
        try {
          const values = JSON.parse(raw);
          if (Array.isArray(values)) raw = values.join('; ');
        } catch (_) {
          raw = raw.replace(/^\[|\]$/g, '').replaceAll('"', '');
        }
      }
      const badge = document.createElement('span');
      badge.className = 'leda-season-badge';
      badge.textContent = seasonLabels[raw] || raw.replaceAll(';', ' ·');
      const gallery = card.querySelector('.card-gallery');
      if (gallery) gallery.appendChild(badge);
    });
  }

  enhanceSeasonFilter();
  let enhancementQueued = false;
  new MutationObserver((mutations) => {
    const hasRelevantNewContent = mutations.some((mutation) =>
      [...mutation.addedNodes].some((node) =>
        node.nodeType === 1 && (node.matches?.('product-card, facet-drawer, .facets') || node.querySelector?.('product-card, facet-drawer, .facets'))
      )
    );
    if (!hasRelevantNewContent || enhancementQueued) return;
    enhancementQueued = true;
    requestAnimationFrame(() => {
      enhancementQueued = false;
      enhanceSeasonFilter();
    });
  }).observe(document.body, { childList: true, subtree: true });
  const themeRules = [
    [/flower|blossom|sakura|cherry/i, 'Flower viewing'],
    [/snow|ski|winter|hokkaido/i, 'Snow & scenery'],
    [/fuji/i, 'Mt Fuji'],
    [/disney|universal|theme park/i, 'Theme parks'],
    [/food|market|culinary/i, 'Local food'],
    [/onsen|hot spring/i, 'Onsen'],
    [/culture|temple|shrine|heritage/i, 'Culture']
  ];

  function enhanceProductCards(root = document) {
    root.querySelectorAll('product-card').forEach((card, index) => {
      const titleNode = card.querySelector('a[ref="productTitleLink"] [role="heading"], .product-grid-view-zoom-out--details h3, .product-title, .product-card__title, [class*="product-title"]');
      const title = titleNode?.textContent?.trim() || '';
      if (!title) return;
      const gallery = card.querySelector('.card-gallery');
      if (gallery && !card.querySelector('.leda-card-favorite')) {
        const favorite = document.createElement('button');
        favorite.type = 'button';
        favorite.className = 'leda-card-favorite';
        favorite.setAttribute('aria-label', 'Add to favourites');
        favorite.innerHTML = '<span aria-hidden="true">♡</span>';
        favorite.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          favorite.classList.toggle('is-active');
          favorite.innerHTML = favorite.classList.contains('is-active') ? '<span aria-hidden="true">♥</span>' : '<span aria-hidden="true">♡</span>';
        });
        gallery.appendChild(favorite);
      }
      if (gallery && !card.querySelector('.leda-card-ribbon') && index % 4 === 0) {
        const ribbon = document.createElement('span');
        ribbon.className = 'leda-card-ribbon';
        ribbon.textContent = index % 8 === 0 ? 'LEDA pick' : 'Must try';
        gallery.appendChild(ribbon);
      }
      if (!card.querySelector('.leda-card-tags')) {
        const tags = document.createElement('div');
        tags.className = 'leda-card-tags';
        const theme = themeRules.find(([pattern]) => pattern.test(title))?.[1];
        if (theme) tags.insertAdjacentHTML('beforeend', `<span class="leda-card-tag is-theme">${theme}</span>`);
        tags.insertAdjacentHTML('beforeend', '<span class="leda-card-tag">Private group</span>');
        if (/family|theme park|disney|universal/i.test(title)) tags.insertAdjacentHTML('beforeend', '<span class="leda-card-tag">Family friendly</span>');
        titleNode.insertAdjacentElement('afterend', tags);
      }
      if (!card.querySelector('.leda-points-note, .leda-card-points')) {
        const price = card.querySelector('product-price, .price, [class*="price"]');
        if (price) price.insertAdjacentHTML('afterend', '<div class="leda-points-note">Earn & redeem LEDA Points</div>');
      }
    });
  }

  function refineFilters(root = document) {
    root.querySelectorAll('details').forEach((details) => {
      if (details.querySelector('input[name*="availability"]')) details.classList.add('leda-filter-hidden');
    });
  }

  function enhanceProductPage(root = document) {
    const nav = root.querySelector('.leda-product-ota-nav');
    if (nav && !nav.dataset.refined) {
      nav.dataset.refined = 'true';
      const links = [...nav.querySelectorAll('a')];
      links.find((a) => /overview|概览/i.test(a.textContent || ''))?.remove();
      const zh = document.documentElement.lang?.toLowerCase().startsWith('zh');
      const priceLink = links.find((a) => /dates|日期/i.test(a.textContent || ''));
      const itineraryLink = links.find((a) => /itinerary|行程/i.test(a.textContent || ''));
      const tailorLink = links.find((a) => /tailor|定制/i.test(a.textContent || ''));
      if (priceLink) priceLink.textContent = zh ? '日期与价格' : 'Availability & price';
      if (itineraryLink) itineraryLink.textContent = zh ? '每日行程' : 'Day-by-day itinerary';
      if (tailorLink) tailorLink.textContent = zh ? '定制此行程' : 'Customize this trip';
    }
    const chips = root.querySelector('.leda-product-intro__chips');
    const title = root.querySelector('.product-information h1')?.textContent || '';
    if (chips && !chips.dataset.contextTagsAdded) {
      chips.dataset.contextTagsAdded = 'true';
      const zh = document.documentElement.lang?.toLowerCase().startsWith('zh');
      const labels = [];
      if (/flower|blossom|sakura|cherry/i.test(title)) labels.push(zh ? '赏花' : 'Flower viewing');
      if (/snow|ski|winter|hokkaido/i.test(title)) labels.push(zh ? '雪景' : 'Snow & scenery');
      if (/fuji/i.test(title)) labels.push(zh ? '富士山' : 'Mt Fuji');
      if (/disney|universal|theme park/i.test(title)) labels.push(zh ? '主题乐园' : 'Theme parks');
      labels.push(zh ? '适合家人与朋友' : 'Families & friends');
      labels.slice(0, 2).forEach((label) => chips.insertAdjacentHTML('beforeend', `<span class="leda-context-chip">${label}</span>`));
    }
  }

  function enhanceAll(root = document) {
    enhanceProductCards(root);
    refineFilters(root);
    enhanceProductPage(root);
  }
  enhanceAll();
  let cardEnhancementQueued = false;
  new MutationObserver((mutations) => {
    if (cardEnhancementQueued || !mutations.some((m) => m.addedNodes.length)) return;
    cardEnhancementQueued = true;
    requestAnimationFrame(() => {
      cardEnhancementQueued = false;
      enhanceAll();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
